<template>
  <div class="view-container">
    <div class="contacts-layout">
      <div class="contacts-left">
        <div class="panel-header"><h4>组织架构</h4></div>
        <div class="org-tree">
          <div v-for="org in orgTree" :key="org.id" class="org-node">
            <div class="org-header" @click="toggleOrg(org.id)">
              <i class="fas" :class="expandedOrgs.includes(org.id) ? 'fa-folder-open' : 'fa-folder'"></i>
              <span>{{ org.name }}</span>
              <span class="org-count">{{ org.memberCount }}</span>
            </div>
            <div v-if="expandedOrgs.includes(org.id)" class="org-members">
              <div v-for="member in org.members" :key="member.id" class="org-member" @click="selectMember(member)">
                <div class="avatar" :style="{ background: member.color }">{{ member.avatar }}</div>
                <span>{{ member.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="contacts-right">
        <template v-if="selectedMember">
          <div class="detail-card">
            <div class="detail-header">
              <div class="avatar large" :style="{ background: selectedMember.color }">{{ selectedMember.avatar }}</div>
              <div class="detail-info">
                <h3>{{ selectedMember.name }}</h3>
                <div class="detail-meta">
                  <span>{{ selectedMember.department }}</span>
                  <span class="dot"></span>
                  <span>{{ selectedMember.position }}</span>
                </div>
                <span class="status-tag" :class="selectedMember.online ? 'online' : 'offline'">{{ selectedMember.online ? '在线' : '离线' }}</span>
              </div>
            </div>
            <div class="detail-body">
              <div class="info-row"><label>手机</label><span>{{ selectedMember.phone }}</span></div>
              <div class="info-row"><label>邮箱</label><span>{{ selectedMember.email }}</span></div>
              <div class="info-row"><label>座机</label><span>{{ selectedMember.tel || '-' }}</span></div>
              <div class="info-row"><label>工号</label><span>{{ selectedMember.empNo }}</span></div>
              <div class="info-row"><label>入职日期</label><span>{{ selectedMember.joinDate }}</span></div>
            </div>
            <div class="detail-actions">
              <button @click="startChat(selectedMember)" class="btn btn-primary"><i class="fas fa-comment-dots"></i> 发消息</button>
              <button class="btn btn-default"><i class="fas fa-phone"></i></button>
              <button class="btn btn-default"><i class="fas fa-video"></i></button>
            </div>
          </div>
        </template>
        <div v-else class="empty-state">
          <i class="fas fa-address-book"></i>
          <p>选择一个联系人查看详情</p>
          <p class="hint">在左侧组织架构中选择成员</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const expandedOrgs = ref([1])
const selectedMember = ref(null)

const orgTree = ref([
  {
    id: 1, name: '技术研发部', memberCount: 15,
    members: [
      { id: 1, name: '张三', avatar: '张', color: '#3b82f6', department: '技术研发部', position: '技术总监', phone: '13800138001', email: 'zhangsan@example.com', empNo: 'EMP001', joinDate: '2020-03-15', online: true },
      { id: 2, name: '李四', avatar: '李', color: '#10b981', department: '技术研发部', position: '高级工程师', phone: '13800138002', email: 'lisi@example.com', empNo: 'EMP002', joinDate: '2021-06-01', online: true },
      { id: 3, name: '王五', avatar: '王', color: '#f59e0b', department: '技术研发部', position: 'UI设计师', phone: '13800138003', email: 'wangwu@example.com', empNo: 'EMP003', joinDate: '2022-01-10', online: false }
    ]
  },
  {
    id: 2, name: '采购部', memberCount: 8,
    members: [
      { id: 4, name: '赵六', avatar: '赵', color: '#8b5cf6', department: '采购部', position: '采购经理', phone: '13800138004', email: 'zhaoliu@example.com', empNo: 'EMP004', joinDate: '2019-08-20', online: true },
      { id: 5, name: '孙七', avatar: '孙', color: '#ef4444', department: '采购部', position: '采购专员', phone: '13800138005', email: 'sunqi@example.com', empNo: 'EMP005', joinDate: '2021-03-05', online: true }
    ]
  },
  {
    id: 3, name: '财务部', memberCount: 6,
    members: [
      { id: 6, name: '周八', avatar: '周', color: '#ec4899', department: '财务部', position: '财务主管', phone: '13800138006', email: 'zhouba@example.com', empNo: 'EMP006', joinDate: '2020-11-01', online: false }
    ]
  },
  {
    id: 4, name: '人事行政部', memberCount: 5,
    members: [
      { id: 7, name: '吴九', avatar: '吴', color: '#06b6d4', department: '人事行政部', position: 'HR经理', phone: '13800138007', email: 'wujiu@example.com', empNo: 'EMP007', joinDate: '2018-05-15', online: true }
    ]
  },
  {
    id: 5, name: '质量管理部', memberCount: 7,
    members: [
      { id: 8, name: '郑十', avatar: '郑', color: '#84cc16', department: '质量管理部', position: '质量经理', phone: '13800138008', email: 'zhengshi@example.com', empNo: 'EMP008', joinDate: '2019-02-10', online: false }
    ]
  }
])

const toggleOrg = (id) => {
  const idx = expandedOrgs.value.indexOf(id)
  if (idx !== -1) expandedOrgs.value.splice(idx, 1)
  else expandedOrgs.value.push(id)
}

const selectMember = (member) => {
  selectedMember.value = member
}

const startChat = (member) => {
  window.$message.info('打开与 ' + member.name + ' 的聊天')
}
</script>

<style scoped>
.view-container { background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); overflow: hidden; max-height: calc(100vh - 110px); }
.contacts-layout { display: flex; height: calc(100vh - 115px); }

.contacts-left { flex: 0 0 300px; border-right: 1px solid #e5e7eb; display: flex; flex-direction: column; }
.panel-header { padding: 14px 16px; border-bottom: 1px solid #e5e7eb; }
.panel-header h4 { margin: 0; font-size: 14px; font-weight: 600; color: #1f2937; }
.org-tree { flex: 1; overflow-y: auto; padding: 8px 0; }

.org-header { display: flex; align-items: center; gap: 10px; padding: 10px 16px; cursor: pointer; font-size: 13px; color: #374151; transition: background 0.15s; }
.org-header:hover { background: #f8fafc; }
.org-header i { color: #06b6d4; font-size: 12px; }
.org-header span { flex: 1; font-weight: 500; }
.org-count { color: #9ca3af; font-size: 11px; background: #f3f4f6; padding: 1px 6px; border-radius: 10px; }

.org-members { padding: 4px 0 4px 12px; }
.org-member { display: flex; align-items: center; gap: 10px; padding: 8px 16px 8px 36px; cursor: pointer; font-size: 13px; color: #6b7280; transition: background 0.15s; }
.org-member:hover { background: #f8fafc; }
.avatar { width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 13px; font-weight: 600; flex-shrink: 0; }
.avatar.large { width: 72px; height: 72px; font-size: 28px; border-radius: 12px; }

.contacts-right { flex: 1; display: flex; align-items: center; justify-content: center; padding: 40px; }
.detail-card { width: 100%; max-width: 480px; }
.detail-header { display: flex; align-items: center; gap: 20px; margin-bottom: 24px; }
.detail-info h3 { margin: 0 0 4px 0; font-size: 20px; color: #1f2937; }
.detail-meta { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #6b7280; margin-bottom: 8px; }
.dot { width: 4px; height: 4px; border-radius: 50%; background: #9ca3af; }
.status-tag { display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 11px; font-weight: 500; }
.status-tag.online { background: #dcfce7; color: #16a34a; }
.status-tag.offline { background: #f3f4f6; color: #9ca3af; }

.detail-body { background: #f9fafb; border-radius: 8px; padding: 16px 20px; margin-bottom: 20px; }
.info-row { display: flex; padding: 8px 0; border-bottom: 1px solid #f3f4f6; font-size: 13px; }
.info-row:last-child { border-bottom: none; }
.info-row label { width: 70px; color: #9ca3af; flex-shrink: 0; }
.info-row span { color: #374151; }

.detail-actions { display: flex; gap: 10px; }
.btn { padding: 8px 18px; border: 1px solid transparent; border-radius: 6px; font-size: 13px; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.2s; }
.btn-primary { background: #06b6d4; color: #fff; border-color: #06b6d4; }
.btn-primary:hover { background: #0891b2; }
.btn-default { background: #fff; color: #374151; border-color: #d1d5db; }
.btn-default:hover { background: #f9fafb; }

.empty-state { text-align: center; color: #9ca3af; }
.empty-state i { font-size: 56px; margin-bottom: 12px; color: #d1d5db; }
.empty-state p { font-size: 14px; margin-bottom: 4px; }
.empty-state .hint { font-size: 12px; color: #d1d5db; }
</style>
